import { render } from "./RateLimitsView.vue?vue&type=template&id=51c07c8d"
import script from "./RateLimitsView.vue?vue&type=script&lang=js"
export * from "./RateLimitsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__